"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var is_variant_available_1 = __importDefault(require("./is-variant-available"));
exports.default = (function (addOns) {
    var e_1, _a, e_2, _b;
    var flattened = [];
    try {
        for (var addOns_1 = __values(addOns), addOns_1_1 = addOns_1.next(); !addOns_1_1.done; addOns_1_1 = addOns_1.next()) {
            var product = addOns_1_1.value;
            try {
                for (var _c = (e_2 = void 0, __values(product.variants)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var variant = _d.value;
                    flattened.push([product, variant]);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (addOns_1_1 && !addOns_1_1.done && (_a = addOns_1.return)) _a.call(addOns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return flattened.sort(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], variant = _b[1];
        return ((0, is_variant_available_1.default)(variant) ? -1 : 1);
    });
});
